module.exports = __webpack_public_path__ + "media/images/social-media/website-b13cf3ab66be766dc36498686e1de31d.svg";